<button
  type="button"
  class="menu-toggle"
  (click)="toggleMenu()"
  [attr.aria-expanded]="menuVisible"
  aria-label="Abrir o cerrar menú"
  title="Menú"
>
  <span class="desktop-toggle">☰</span>
  <mat-icon class="mobile-toggle">{{ menuVisible ? "close" : "apps" }}</mat-icon>
</button>

<!-- Escritorio: sidebar clásico, como estaba antes -->
<aside class="sidebar-classic" [class.oculto]="!menuVisible">
  <div class="classic-logo" routerLink="/home">
    <img
      src="../../../../assets/img/Zivo_only_logo.png"
      alt="logo"
      class="classic-logo-img"
    />
    <span class="classic-logo-text">IVO</span>
  </div>

  <div class="classic-scroll">
    <nav *ngIf="menu.length > 0">
      <div *ngFor="let grupo of menu" class="classic-menu-group">
        <button
          type="button"
          class="classic-module-toggle"
          [class.has-active-route]="hayRutaActiva(grupo.items)"
          (click)="toggleSubmenu(grupo.categoria)"
          [attr.aria-expanded]="submenuAbierto[grupo.categoria] || false"
          [attr.aria-controls]="'classic-menu-' + grupo.clave"
        >
          <span>{{ grupo.categoria }}</span>
          <mat-icon class="classic-arrow">
            {{ submenuAbierto[grupo.categoria] ? "expand_less" : "expand_more" }}
          </mat-icon>
        </button>

        <div
          [id]="'classic-menu-' + grupo.clave"
          [hidden]="!submenuAbierto[grupo.categoria]"
        >
          <ng-container
            *ngTemplateOutlet="classicItems; context: { $implicit: grupo.items, level: 0 }"
          ></ng-container>
          <ul *ngIf="grupo.clave === 'kyara-ai'" class="classic-items">
            <li>
              <button
                type="button"
                class="classic-link"
                (click)="navegar({ nombre: 'Configuración Copilot empresarial', ruta: '/ai/copilot-settings' })"
              >
                Configuración Copilot empresarial
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <ng-template #classicItems let-items let-level="level">
      <ul
        class="classic-items"
        [class.classic-subgroup-children]="level > 0"
      >
        <ng-container *ngFor="let item of items">
          <li *ngIf="esEnlace(item)">
            <button
              type="button"
              class="classic-link"
              [class.is-active]="estaActivo(item)"
              [attr.aria-current]="estaActivo(item) ? 'page' : null"
              (click)="navegar(item)"
              [title]="item.nombre"
            >
              {{ item.ruta === "/ai/kyara" ? "Asistente IA clásico" : item.nombre }}
            </button>
          </li>

          <li
            *ngIf="esSubgrupo(item)"
            class="classic-subgroup"
            [class.has-active-child]="contieneRutaActiva(item)"
          >
            <button
              type="button"
              class="classic-subgroup-toggle"
              (click)="toggleSubgrupo(item.clave)"
              [attr.aria-expanded]="subgrupoAbierto[item.clave] || false"
              [attr.aria-controls]="'classic-subgroup-' + item.clave"
            >
              <span>{{ item.nombre }}</span>
              <mat-icon>
                {{ subgrupoAbierto[item.clave] ? "expand_less" : "expand_more" }}
              </mat-icon>
            </button>

            <div
              [id]="'classic-subgroup-' + item.clave"
              [hidden]="!subgrupoAbierto[item.clave]"
            >
              <ng-container
                *ngTemplateOutlet="classicItems; context: { $implicit: item.items, level: level + 1 }"
              ></ng-container>
            </div>
          </li>
        </ng-container>
      </ul>
    </ng-template>

    <div *ngIf="menu.length === 0" class="classic-no-permisos">
      <p>🚫 No tienes permisos asignados.</p>
    </div>
  </div>

  <button class="classic-logout-btn" (click)="cerrarSesion()">Cerrar sesión</button>
</aside>

<!-- Móvil: launcher de aplicaciones aprobado -->
<aside class="sidebar sidebar-mobile sidebar--erp" [class.oculto]="!menuVisible">
  <div class="sidebar-header">
    <div class="logo" routerLink="/home" title="Ir al inicio">
      <div class="logo-mark">
        <img
          src="../../../../assets/img/Zivo_only_logo.png"
          alt="ZIVO"
          class="logo-img"
        />
      </div>
      <div class="brand-copy">
        <strong>ZIVO</strong>
        <span>Centro de aplicaciones</span>
      </div>
    </div>
  </div>

  <div class="sidebar-scroll">
    <div class="launcher-heading" *ngIf="menu.length > 0">
      <span>Aplicaciones</span>
      <small>{{ menu.length }} módulos disponibles</small>
    </div>

    <nav *ngIf="menu.length > 0" class="app-launcher" aria-label="Aplicaciones ZIVO">
      <section
        *ngFor="let grupo of menu"
        class="menu-group"
        [class.expanded]="submenuAbierto[grupo.categoria]"
        [attr.data-key]="grupo.clave"
      >
        <button
          type="button"
          class="app-card"
          [class.has-active-route]="hayRutaActiva(grupo.items)"
          (click)="toggleSubmenu(grupo.categoria); $event.stopPropagation()"
          [attr.aria-expanded]="submenuAbierto[grupo.categoria] || false"
        >
          <span class="app-icon" aria-hidden="true">
            <mat-icon>apps</mat-icon>
          </span>

          <span class="app-card-copy">
            <strong>{{ grupo.categoria }}</strong>
            <small>{{ contarAccesos(grupo.items) }} accesos</small>
          </span>

          <mat-icon class="chevron">
            {{ submenuAbierto[grupo.categoria] ? "expand_less" : "expand_more" }}
          </mat-icon>
        </button>

        <div [hidden]="!submenuAbierto[grupo.categoria]">
          <ng-container
            *ngTemplateOutlet="mobileItems; context: { $implicit: grupo.items, level: 0 }"
          ></ng-container>

          <div *ngIf="grupo.clave === 'kyara-ai'" class="mobile-special-link">
            <button
              type="button"
              class="app-link"
              (click)="navegar({ nombre: 'Configuración Copilot empresarial', ruta: '/ai/copilot-settings' })"
              title="Configuración Copilot empresarial"
            >
              <span class="mini-icon" aria-hidden="true">
                <mat-icon>settings_suggest</mat-icon>
              </span>
              <span class="app-link-copy">Configuración Copilot empresarial</span>
              <mat-icon class="launch-icon">arrow_forward_ios</mat-icon>
            </button>
          </div>
        </div>
      </section>
    </nav>

    <ng-template #mobileItems let-items let-level="level">
      <ul
        class="app-list mobile-entry-list"
        [class.mobile-subgroup-children]="level > 0"
      >
        <ng-container *ngFor="let item of items">
          <li *ngIf="esEnlace(item)">
            <button
              type="button"
              class="app-link"
              [class.is-active]="estaActivo(item)"
              [attr.aria-current]="estaActivo(item) ? 'page' : null"
              (click)="navegar(item)"
              [title]="item.nombre"
            >
              <span class="mini-icon" aria-hidden="true">
                <mat-icon>{{ item.soloMovil ? "track_changes" : "widgets" }}</mat-icon>
              </span>
              <span class="app-link-copy">
                {{ item.ruta === "/ai/kyara" ? "Asistente IA clásico" : item.nombre }}
              </span>
              <mat-icon class="launch-icon">arrow_forward_ios</mat-icon>
            </button>
          </li>

          <li
            *ngIf="esSubgrupo(item)"
            class="mobile-subgroup"
            [class.has-active-child]="contieneRutaActiva(item)"
          >
            <button
              type="button"
              class="mobile-subgroup-toggle"
              (click)="toggleSubgrupo(item.clave)"
              [attr.aria-expanded]="subgrupoAbierto[item.clave] || false"
              [attr.aria-controls]="'mobile-subgroup-' + item.clave"
            >
              <span>{{ item.nombre }}</span>
              <mat-icon>
                {{ subgrupoAbierto[item.clave] ? "expand_less" : "expand_more" }}
              </mat-icon>
            </button>

            <div
              [id]="'mobile-subgroup-' + item.clave"
              [hidden]="!subgrupoAbierto[item.clave]"
            >
              <ng-container
                *ngTemplateOutlet="mobileItems; context: { $implicit: item.items, level: level + 1 }"
              ></ng-container>
            </div>
          </li>
        </ng-container>
      </ul>
    </ng-template>

    <div *ngIf="menu.length === 0" class="no-permisos">
      <mat-icon>lock</mat-icon>
      <strong>Sin aplicaciones disponibles</strong>
      <p>No tienes permisos asignados para visualizar módulos.</p>
    </div>
  </div>

  <div class="sidebar-footer">
    <button type="button" class="logout-btn" (click)="cerrarSesion()">
      <mat-icon>logout</mat-icon>
      <span>Cerrar sesión</span>
    </button>
  </div>
</aside>
